// @ts-nocheck
import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
	selector: '[ngTryFor][ngTryForOf]',
})
export class NgTryForDirective {
	private view = inject(ViewContainerRef);
	private template = inject<TemplateRef<any>>(TemplateRef);


	@Input('ngTryForOf')
	set ngTryFor(collection) {
		try {
			this.view.clear();
			if (!collection && !Array.isArray(collection)) {
				throw "Null collection or it isn't an array";
			}
			collection.forEach((item, index) => {
				if (item) this.view.createEmbeddedView(this.template, { $implicit: item, index });
			});
		} catch (error) {
			// console.warn(error);
		}
	}
}
